module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1510-e4077f33730387b0cc624cfb1a21ebe8.png";